/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { httpsCallable, HttpsCallableResult } from 'firebase/functions';
import isEmpty from 'lodash/isEmpty';
import { userAsPromise } from '../providers/userProvider';
import { IAthlete, IAthleteEntity, IExternalProperties } from '../types';

/**
 * @description creates/updates athletes
 * @param athletes
 */
export const saveAthletes = async (
  athletes: Array<Partial<IAthlete>>
): Promise<HttpsCallableResult<unknown>> => {
  const requestingUser = await userAsPromise();
  /// namespace external properties if necessary

  const athletesToSave = athletes.map(
    (athlete: Partial<IAthlete>): Partial<IAthleteEntity> => {
      return {
        ...athlete,
        external: {
          [requestingUser.orgId]: validExternalObject(athlete?.external),
        },
      };
    }
  );

  const fn = httpsCallable(requestingUser.services.functions, 'saveAthletes');
  return fn(athletesToSave);
};

const validExternalObject = (
  properties: IExternalProperties
): IExternalProperties => {
  if (!properties) return {};
  const validProperties: IExternalProperties = {};
  for (const [key, value] of Object.entries(properties)) {
    if (key.length > 0 && value !== undefined) {
      validProperties[key] = value;
    }
  }
  return validProperties;
};

/**
 * @description parses external properties from column header
 * @param athlete - object containing potential external:* keys
 * @returns
 */
export const parseExternalProperties = (
  athlete: Record<string, unknown> & { external?: IExternalProperties }
): IExternalProperties | void => {
  const capturePattern = /^external:(.*)/;
  const externalProperties: IExternalProperties = {};
  for (const [key, value] of Object.entries(athlete)) {
    const match = key.match(capturePattern);
    if (match?.[1] && typeof value === 'string') {
      externalProperties[match[1]] = value;
    }
  }
  /// use parsed properties if they exist
  if (Object.keys(externalProperties).length > 0) {
    return externalProperties;
  }
  /// otherwise use existing properties if they have previously been parsed
  if (!isEmpty(athlete.external)) {
    return athlete.external;
  }
};

interface IMergeAthleteRequest {
  toAthleteId: string;
  fromAthleteId: string;
}

export async function mergeAthlete(
  request: IMergeAthleteRequest
): Promise<HttpsCallableResult<unknown>> {
  const requestingUser = await userAsPromise();
  const fn = httpsCallable(requestingUser.services.functions, 'mergeAthlete');
  return fn(request);
}
